<script setup>
import { ref, computed, onBeforeMount } from "vue";
import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useUrlsStore } from "@/stores/urls";

const uiStore = useUiStore();
const urlsStore = useUrlsStore();
const company_id = useCompanyStore().companyId;

const emit = defineEmits(["refresh"]);
let id = ref(null);
let name = ref(null);
let isSubmitted = ref(false);
const getModalAction = computed(() => uiStore.modalAction);

const resetStoreData = () => {
  uiStore.resetModalStore();
};

const onSubmit = () => {
  isSubmitted.value = true;

  urlsStore
    .deleteUrl({ id: id.value, company_id })
    .then(() => {
      resetStoreData();
      emit("refresh");
    })
    .catch(() => {
      isSubmitted.value = false;
    });
};

onBeforeMount(() => {
  if (uiStore.modalData && uiStore.modalAction == "delete_url") {
    id.value = uiStore.modalData.id;
    name.value = uiStore.modalData.name;
  }
});
</script>
<template>
  <DModal v-if="getModalAction === 'delete_url'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Delete Website </template>

    <template #body>
      <div class="delete-text mb-3">
        <span
          >Are you sure you want to <b>"Delete"</b> the Website
          <b>{{ name }}</b> ?</span
        >
      </div>
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button
            @click="resetStoreData"
            type="button"
            class="btn btn-secondary cancel-button"
          >
            Cancel
          </button>
          <button
            :disabled="isSubmitted"
            @click="onSubmit"
            type="button"
            class="btn btn-danger add-button mr-30"
          >
            Delete
            <span
              v-if="isSubmitted"
              class="spinner-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
